import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Kies hieronder welke kolommen voor jou zichtbaar moeten zijn.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { computed, onMounted, ref, withDefaults } from 'vue'
import { ls } from '@/ls'
import Column from '@/types/column'
import { SettingOutlined } from '@ant-design/icons-vue'
import axios from 'axios'
import _ from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnSettings',
  props: {
    columns: null,
    storageName: null
  },
  emits: ['hiddenColumnsChanged'],
  setup(__props: any, { emit }) {

const props = __props as { columns:Column[], storageName: string };



const screenWidth = computed(() => window.innerWidth)

const showColumnSettingModal = ref(false)
const hiddenColumns = ref<string[]>(ls.get(props.storageName) || [])

onMounted(() => {
  emit('hiddenColumnsChanged', _.clone(hiddenColumns.value, true))
})

function toggleColumn (checked:boolean, column:string): void {
  if (!checked) {
    hiddenColumns.value.push(column)
  } else {
    hiddenColumns.value.splice(hiddenColumns.value.indexOf(column), 1)
  }
}

function saveColumnSettings () : void {
  ls.set(props.storageName, hiddenColumns.value)
  emit('hiddenColumnsChanged', _.clone(hiddenColumns.value, true))
  closeColumnModal()
  axios.post(process.env.VUE_APP_API_URL + '/users/constructionSiteApp/settings', {
    settingName: props.storageName,
    settingValue: hiddenColumns.value
  })
}

function closeColumnModal () : void {
  hiddenColumns.value = ls.get(props.storageName)
  showColumnSettingModal.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "column-settings",
    style: _normalizeStyle(_unref(screenWidth) <= 1024 ? { marginBottom: '8px' } : {})
  }, [
    _createVNode(_component_a_button, {
      type: hiddenColumns.value.length ? 'primary' : 'default',
      size: _unref(screenWidth) <= 1024 ? '' : 'small',
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showColumnSettingModal.value = true))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(SettingOutlined))
      ]),
      _: 1
    }, 8, ["type", "size"]),
    _createVNode(_component_a_modal, {
      title: "Zichtbare kolommen instellen.",
      visible: showColumnSettingModal.value,
      "ok-text": "Opslaan",
      onOk: saveColumnSettings,
      onCancel: closeColumnModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { class: "no-mb" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_1,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: column.key
                  }, [
                    _createVNode(_component_a_checkbox, {
                      checked: !hiddenColumns.value.includes(column.key),
                      onChange: ($event: any) => (toggleColumn($event.target.checked, column.key))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(column.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["checked", "onChange"]),
                    _hoisted_2
                  ], 64))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 4))
}
}

})